module.exports = __webpack_public_path__ + "static/media/img_3.c656ae1f.png";